module.exports = __webpack_public_path__ + "static/media/invites_paper@2x.2e79cc92.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/invites_paper@2x.png
 ** module id = 887
 ** module chunks = 50
 **/